<template>
  <div>
    <img src="@/assets/img/d_1.png" class="bjImg" alt="">
    <div class="boxCont">
      <div class="boxCont_padd outer_one">
        <div class="outer_one_1 animate__animated animation_title">汰汰清单</div>
        <div class="outer_one_2 animate__animated animation_title">简单高效，记录更便捷</div>
      </div>
      <div class="boxCont_padd outer_two animate__animated animation_title">
        <div class="outer_two_cont settingStyle elementHover"
          :style="'backgroundImage:url(' + require('@/assets/img/d_2.png') + ')'">
          <div class="outer_two_cont_left">
            <img src="@/assets/img/d_3.png" class="outer_two_cont_lef_1" alt="">
            <div class="outer_two_cont_lef_2">个人管理生活琐事 工作和学习中提升效率</div>
          </div>
          <div class="outer_two_cont_right" @click="downloadApp">下载APP</div>
        </div>
      </div>
      <div class="boxCont_padd outer_tip animate__animated animation_title">来了解一下我们</div>
      <div class="outer_three">
        <div class="outer_three_one">
          <div class="outer_three_one_cont">
            <div class="outer_three_item elementHover" :id="'outer_three_item'+index"
              :style="'transition-delay:'+ 0.1 * (index+1)+'s'" v-for="(item, index) in aboutList" :key="index">
              <img :src="item.image" class="outer_three_item_img" alt="">
              <div :class="['outer_three_item_cont','outer_three_item_cont'+item.color]">
                <div class="outer_three_item_cont_1">{{item.title}}</div>
                <div class="outer_three_item_cont_2">{{item.description}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="boxCont_padd outer_three_two">
          <img src="@/assets/img/d_4.png" @click="leftFn" class="outer_three_two_1" alt="">
          <img src="@/assets/img/d_5.png" @click="rightFn" class="outer_three_two_1" alt="">
        </div>
      </div>
      <div class="boxCont_padd outer_four">
        <div class="outer_tip outer_tip_2 animate__animated">数据安全与隐私保护</div>
        <div class="outer_four_cont">
          <div class="outer_four_cont_item animate__animated">
            <div class="outer_four_cont_item_1">
              <div class="outer_four_cont_item_1_1">数据加密</div>
              <img src="@/assets/img/d_6.png" class="outer_four_cont_item_1_2" alt="">
            </div>
            <div class="outer_four_cont_item_2">端到端加密</div>
            <div class="outer_four_cont_item_3">所有用户数据在传输和存储过程中都采用端到端加密技术。无论是在用户设备上传输数据，还是在云端存储时，数据都会被加密处理，确保中途</div>
            <div class="outer_four_cont_item_2">加密算法</div>
            <div class="outer_four_cont_item_3">
              采用先进的加密算法（如AES-256和RSA）确保数据的安全性。即便数据在云端存储，也只有授权的用户和应用能够访问，其他任何未经授权的请求将被拒绝。</div>
            <div class="outer_four_cont_item_2">加密算法</div>
            <div class="outer_four_cont_item_3">数据在设备本地和云端存储时都进行加密处理，确保即使设备丢失或遭遇攻击，数据不会被泄露。</div>
          </div>
          <div class="outer_four_cont_item animate__animated">
            <div class="outer_four_cont_item_1">
              <div class="outer_four_cont_item_1_1">用户隐私保护</div>
              <img src="@/assets/img/d_7.png" class="outer_four_cont_item_1_2" alt="">
            </div>
            <div class="outer_four_cont_item_2 outer_four_cont_item_color">符合全球隐私法规</div>
            <div class="outer_four_cont_item_3">
              汰汰清单严格遵守各类全球隐私保护法规，确保在收集、存储、处理和共享用户数据时符合相关法律要求。</div>
            <div class="outer_four_cont_item_2 outer_four_cont_item_color">数据存储地点选择</div>
            <div class="outer_four_cont_item_3">
              用户可以根据所在区域选择数据存储位置，确保数据存储符合当地的法律和隐私要求，并遵守数据本地化的政策。</div>
            <div class="outer_four_cont_item_2 outer_four_cont_item_color">用户权利保障</div>
            <div class="outer_four_cont_item_3">我们尊重用户的隐私权，并提供删除个人数据、修改个人信息、访问个人数据的功能，用户可以随时行使自己的数据权利，保护个人隐私。</div>
          </div>
        </div>
      </div>
      <div class="boxCont_padd outer_five">
        <div class="outer_tip outer_tip_3 animate__animated">爱记录选择我们</div>
        <div class="outer_five_one animate__animated">
          <div class="outer_five_one_left">
            <div class="outer_five_one_left_1">简单操作</div>
            <div class="outer_five_one_left_2">待办事项清单</div>
            <div class="outer_five_one_left_3">提供任务清单管理功能，用户可以创建和编辑各类任务。</div>
            <div class="outer_five_one_left_3">每个任务支持设定优先级、截止时间和提醒功能，确保重要事项不被遗漏。</div>
            <div class="outer_five_one_left_3">支持任务的完成标记，已完成的任务会自动归档并可随时查看。</div>
          </div>
          <img src="@/assets/img/d_8.png" class="outer_five_one_right" alt="">
        </div>
        <div class="outer_five_two">
          <div class="outer_five_two_one animate__animated settingStyle"
            :style="'backgroundImage:url(' + require('@/assets/img/d_9.png') + ')'">
            <div class="outer_five_two_one_1">
              <div class="outer_five_two_one_1_cont">
                <div class="outer_five_two_one_1_cont_1">请添加事项...</div>
                <img src="@/assets/img/d_5.png" class="outer_five_two_one_1_cont_2" alt="">
              </div>
            </div>
            <div class="outer_five_two_one_2">
              <div class="outer_five_two_one_2_one">今天</div>
              <div class="outer_five_two_one_2_one">明天</div>
              <img src="@/assets/img/d_10.png" class="outer_five_two_one_2_two" alt="">
            </div>
          </div>
          <div class="outer_five_two_two animate__animated">
            <div class="outer_five_two_two_one">
              <div class="outer_five_two_two_one_1">快速选择</div>
              <div class="outer_five_two_two_one_2">完成时间管理</div>
            </div>
            <img src="@/assets/img/d_11.png" class="outer_five_two_two_two" alt="">
          </div>
        </div>
      </div>
      <commonFoot class="commonFoot animate__animated" type="2"></commonFoot>

    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 汰汰清单详情
  // @author: 刘嘉鑫
  import commonFoot from "@/components/commonFoot.vue";
  export default {
    components: {
      commonFoot,
    },
    data() {
      return {
        aboutList: "",
        aboutIndex: 0,
      }
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScrollbox, true);
    },
    mounted() {
      this.getInfo()
      window.addEventListener("scroll", this.handleScrollbox, true);
    },
    methods: {
      // 详情
      getInfo() {
        this.$request({
          url: "/Index/aboutUs",
        }).then((res) => {
          console.log("详情", res);
          this.aboutList = res.about_us;
        });
      },

      // 下载App
      downloadApp() {
        this.$router.push({
          path: "downloadApp",
        });
      },

      leftFn() {
        this.aboutIndex = this.aboutIndex == 0 ? 0 : this.aboutIndex - 1
        const el = document.getElementById('outer_three_item' + this.aboutIndex);
        // console.log("往左", this.aboutIndex, el.getBoundingClientRect().left)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      },
      rightFn() {
        this.aboutIndex = this.aboutIndex >= this.aboutList.length - 1 ? this.aboutList.length - 1 : this.aboutIndex + 1
        const el = document.getElementById('outer_three_item' + this.aboutIndex);
        // console.log("往右", this.aboutIndex, el.getBoundingClientRect().left)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      },

      /**
       * 动画效果
       * 刘嘉鑫
       * 2025-1-15
       */
      handleScrollbox() {
        this.currentScroll = window.pageYOffset; //表示当前滚动的位置
        // 来了解我们
        if (this.currentScroll >= this.$(".outer_two").offset().top - 950) {
          this.$(".outer_three_item").addClass("showDiv");
        }
        //  数据安全
        if (this.currentScroll >= this.$(".outer_three").offset().top - 100) {
          this.$(".outer_tip_2").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_three").offset().top + 100) {
          this.$(".outer_four_cont_item").addClass(" animation_title");
        }
        // 爱记录
        if (this.currentScroll >= this.$(".outer_four").offset().top + 200) {
          this.$(".outer_tip_3").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top + 400) {
          this.$(".outer_five_one").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top + 800) {
          this.$(".outer_five_two_one").addClass(" animation_title");
          this.$(".outer_five_two_two").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top + 1200) {
          this.$(".commonFoot").addClass(" animation_title");
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1036px;
  }

  .boxCont_padd {
    padding-left: 160px;
    padding-right: 160px;
  }

  .boxCont {
    position: relative;
    z-index: 99;
    padding: 190px 0 0;
  }

  .outer_one {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 80px;

    .outer_one_1 {
      font-weight: 700;
      font-size: 54px;
      color: #2A303A;
      letter-spacing: 6px;
    }

    .outer_one_2 {
      font-weight: 700;
      font-size: 22px;
      color: #333A47;
      letter-spacing: 2px;
    }
  }

  .outer_two {
    position: relative;
    margin-bottom: 100px;

    .outer_two_cont {
      position: relative;
      padding: 120px 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .outer_two_cont_left {
        .outer_two_cont_lef_1 {
          padding-left: 10px;
          width: 354px;
          height: 102px;
          margin-bottom: 80px;
        }

        .outer_two_cont_lef_2 {
          font-weight: 400;
          font-size: 19px;
          color: #FFFFFF;
          letter-spacing: 2px;
        }
      }

      .outer_two_cont_right {
        background: #FFFFFF;
        border-radius: 66px;
        padding: 15px 34px;
        font-weight: bold;
        font-size: 17px;
        color: #0057FE;
        cursor: pointer;
      }
    }
  }

  .outer_tip {
    font-weight: 400;
    font-size: 42px;
    color: #2A303A;
    margin-bottom: 80px;
    opacity: 0;
    letter-spacing: 3px;
  }

  .outer_three {
    padding-bottom: 60px;

    .outer_three_one {
      overflow-x: auto;
      /* 使容器可以水平滚动 */
      white-space: nowrap;
      /* 禁止换行 */
      margin-bottom: 40px;

      .outer_three_one_cont {
        display: inline-flex;
        height: 620px;
        /* 使子div在一行内显示 */
      }

      .outer_three_item {
        white-space: wrap;
        /* 禁止换行 */
        width: 440px;
        height: 600px;
        margin-top: 10px;
        position: relative;
        background: linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%);
        border-radius: 40px;
        overflow: hidden;
        margin-right: 40px;
        transition: all 0.7s ease-out 0s;
        transform: translate(0px, 70px);
        opacity: 0;
        cursor: pointer;
       

        .outer_three_item_img {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover !important;
        }

        .outer_three_item_cont {
          position: relative;
          padding: 54px 45px;

          .outer_three_item_cont_1 {
            font-weight: 700;
            font-size: 26px;
            color: #333A47;
            margin-bottom: 18px;
            letter-spacing: 3px;
          }

          .outer_three_item_cont_2 {
            font-weight: 400;
            font-size: 16px;
            color: #5D6574;
            line-height: 28px;
            letter-spacing: 2px;
          }
        }

        .outer_three_item_cont1>div {
          color: #ffffff !important;
        }

        .outer_three_item_cont2>div {
          color: #333A47 !important;
        }
      }

      .outer_three_item:first-child {
        margin-left: 160px;
      }

      .outer_three_item:last-child {
        margin-right: 160px;
      }
    }

    .outer_three_two {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .outer_three_two_1 {
        width: 36px;
        height: 36px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }

  .outer_four {
    background: linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%);
    padding-top: 100px;
    padding-bottom: 100px;

    .outer_four_cont {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;

      .outer_four_cont_item {
        padding: 28px 40px 18px 46px;
        background: #FFFFFF;
        border-radius: 40px;
        opacity: 0;

        .outer_four_cont_item_1 {
          display: flex;
          justify-content: space-between;
          margin-bottom: 32px;

          .outer_four_cont_item_1_1 {
            font-weight: 700;
            font-size: 28px;
            color: #333A47;
            margin-top: 22px;
            letter-spacing: 3px;
          }

          .outer_four_cont_item_1_2 {
            width: 92px;
            height: 92px;
          }
        }

        .outer_four_cont_item_color {
          color: #FE5A00 !important;
        }

        .outer_four_cont_item_2 {
          font-weight: bold;
          font-size: 18px;
          color: #0057FE;
          margin-bottom: 18px;
          letter-spacing: 2px;
        }

        .outer_four_cont_item_3 {
          font-weight: 400;
          font-size: 16px;
          color: #5D6574;
          line-height: 28px;
          margin-bottom: 42px;
          letter-spacing: 2px;
        }
      }
    }
  }

  .outer_five {
    padding-top: 100px;
    padding-bottom: 60px;

    .outer_five_one {
      background: linear-gradient(180deg, rgba(239, 247, 255, .8) 0%, rgba(230, 236, 244, .8) 100%);
      border-radius: 40px;
      padding: 84px 200px 0;
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
      opacity: 0;

      .outer_five_one_left {
        padding-top: 20px;
        width: 28%;

        .outer_five_one_left_1 {
          font-weight: 700;
          font-size: 24px;
          color: #0057FE;
          margin-bottom: 23px;
          letter-spacing: 2px;
        }

        .outer_five_one_left_2 {
          font-weight: 700;
          font-size: 28px;
          color: #333A47;
          margin-bottom: 40px;
          letter-spacing: 3px;
        }

        .outer_five_one_left_3 {
          font-weight: 400;
          font-size: 17px;
          color: #5D6574;
          margin-bottom: 36px;
          letter-spacing: 2px;
        }
      }

      .outer_five_one_right {
        width: 466px;
        height: 456px;
      }
    }

    .outer_five_two {
      display: flex;


      .outer_five_two_one {
        padding: 52px 130px 56px;
        width: 44%;
        opacity: 0;

        .outer_five_two_one_1 {
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 1) 100%);
          padding: 4px;
          border-radius: 66px;
          margin-bottom: 32px;

          .outer_five_two_one_1_cont {
            /* background: linear-gradient(180deg, rgba(255, 255, 255, .1) 0%, rgba(255, 255, 255, .1) 100%); */
            border-radius: 66px;
            padding: 19px 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .outer_five_two_one_1_cont_1 {
              font-weight: 400;
              font-size: 22px;
              color: #2A303A;
              letter-spacing: 2px;
            }

            .outer_five_two_one_1_cont_2 {
              width: 44px;
              height: 44px;
            }
          }
        }

        .outer_five_two_one_2 {
          display: flex;
          align-items: center;
          padding: 0 40px 0 30px;


          .outer_five_two_one_2_one {
            font-weight: 700;
            font-size: 24px;
            color: #FFFFFF;
            margin-right: 28px;
            letter-spacing: 2px;
          }

          .outer_five_two_one_2_two {
            width: 32px;
            height: 32px;
            margin-left: auto;
          }
        }
      }

      .outer_five_two_two {
        background: #0057FE;
        border-radius: 40px;
        padding: 0 78px 0 100px;
        display: flex;
        align-items: center;
        width: 25.7%;
        margin-left: auto;
        opacity: 0;

        .outer_five_two_two_one {
          .outer_five_two_two_one_1 {
            font-weight: 700;
            font-size: 24px;
            color: #FFFFFF;
            margin-bottom: 23px;
            letter-spacing: 2px;
          }

          .outer_five_two_two_one_2 {
            font-weight: 700;
            font-size: 28px;
            color: #FFFFFF;
            letter-spacing: 3px;
          }
        }

        .outer_five_two_two_two {
          width: 90px;
          height: 72px;
          margin-left: auto;
        }
      }
    }
  }

  .commonFoot {
    opacity: 0;
  }
</style>